export default __webpack_public_path__ + "static/blob4-20edb76eb3e5cd88dba96c46005393ab.svg";